import { CreateElement, Point, Rect, SetStyles, Size } from "../.././MyHelpers";
import { DecodedImageResource } from "../../ResourceManager/ImageResource";
import { ZIndex } from "../../ZIndex";
import { PlayWindow } from "../../api";
import { MyCanvas } from "../MyCanvas";
import { ReelSetMapper } from "./ReelSetMapper";
import { SpinAnimation } from "./SpinAnimation";


export interface  SpinnableReelsParams
{
	topBorderWidth?: number;
	bottomBorderWidth?: number;
	leftBorderWidth?: number;
	rightBorderWidth?: number;
	backgroundImage?: DecodedImageResource;
	maskbackgroundImage?: DecodedImageResource;
}

export interface  ISpinnableReels
{
	GetWindowSymbolSize(): PlayWindow;
	GetSymbolSize(): Size;
	GetWindowRect(): Rect;
	GetSymbolRect(column: number, row: number): Rect;
	GetAbsoluteSymbolRectReelRow(reel: number, rowOnReel: number): Rect;
	CanvasesReelRow(): MyCanvas[][];
}

export class SpinnableReels implements ISpinnableReels {

	//protected numReels: number = 0;
	//protected numRows: number = 0;

	// window size in number of symbols
	protected windowSymbolSize: PlayWindow

	// total window size in number of ymbols, including hidden symbols
	protected extendedWindowSymbolSize: Size


	// additional rows to add on tom of animation
	public readonly numAdditionalRowsTop: number = 1;

	// size of whole window, in pixels
	protected windowRect: Rect;

	// size of one symbol. in pixels
	protected symbolSize: Size;

	protected centerOfReel: Point[] = [];

	//protected symbolWidth: number = 0;
	//protected symbolHeight: number = 0;

	protected slotWindowElement: HTMLElement = null;
	protected reelWindowElemsList: HTMLElement [] = [];
	public get ReelWindowElements(): HTMLElement[] 
	{
		return this.reelWindowElemsList;
	}

	protected reelElemsList: HTMLElement[] = [];
	public get ReelElements(): HTMLElement[]
	{
		return this.reelElemsList;
	}

	protected spinAnimation: SpinAnimation = null;
	protected reelSetMapper: ReelSetMapper = null;

	protected logGroup: string = "SpinnableReels";

	// canvas element for each symbol
	// first index = reel index
	// second index = row index
	public canvas: MyCanvas[][] = [];
	public symbolsContainer: HTMLElement[][] = [];

	protected params: SpinnableReelsParams = null;

	public constructor(windowSymbolsSize: PlayWindow, windowRect: Rect, params: SpinnableReelsParams = null) {
		this.windowSymbolSize = windowSymbolsSize;

		this.params = params;

		// fill in default values to simplify flow
		if (!this.params) this.params = {};
		if (!this.params.topBorderWidth) this.params.topBorderWidth = 0;
		if (!this.params.rightBorderWidth) this.params.rightBorderWidth = 0;
		if (!this.params.bottomBorderWidth) this.params.bottomBorderWidth = 0;
		if (!this.params.leftBorderWidth) this.params.leftBorderWidth = 0;

		// extended size, for hidden symbols on top
		this.extendedWindowSymbolSize = new Size(windowSymbolsSize.Width, windowSymbolsSize.Height + this.numAdditionalRowsTop);
		this.windowRect = windowRect;

		// find symbol size, based on window size and number of reels/rows
		let windowInnerWidth = this.windowRect.width - this.params.leftBorderWidth - this.params.rightBorderWidth;
		let windowInnerHeight = this.windowRect.height - this.params.topBorderWidth - this.params.bottomBorderWidth;

		// this is now inner window size, reduced by border
		let windowInnerRect = new Rect(this.params.leftBorderWidth, this.params.topBorderWidth, windowInnerWidth, windowInnerHeight);

		//// Log.Debug(this.logGroup, "Inner window rect (borders compensated): " + windowInnerRect.toString());

		let symbolWidth = windowInnerRect.width / this.windowSymbolSize.Width;
		// if (symbolWidth - Math.round(symbolWidth) != 0) {
		// 	Log.Error(this.logGroup, "Window width is not equally divisible by number of symbols: window width = " + this.windowRect.width + ", reels = " + this.windowSymbolSize.width);
		// }

		let symbolHeight = windowInnerRect.height / this.windowSymbolSize.Height;
		// if (symbolHeight - Math.round(symbolHeight) != 0) {
		// 	Log.Error(this.logGroup, "Window height is not equally divisible by number of symbols: window height = " + this.windowRect.height + ", symbols = " + this.windowSymbolSize.height);
		// }

		this.symbolSize = new Size(Math.round(symbolWidth), Math.round(symbolHeight));
		
		this.ConstructReels();
	}

	protected ConstructReels() {

		// prepare slot window
		this.slotWindowElement = CreateElement("div", {classes: ["spinnablereels-slotwindow"], style: {
			position: "absolute",
			left: this.windowRect.x + "px",
			top: this.windowRect.y + "px",
			width: this.windowRect.width + "px",
			height: this.windowRect.height + "px"
		}});

		// prepare reels
		for (let ri = 0; ri < this.extendedWindowSymbolSize.Width; ri++) {

			this.canvas.push([]);
			this.symbolsContainer.push([]);

			// prepare  reelwindow and reel
			let reelWindowElem: HTMLElement = CreateElement("div", {classes: ["spinnablereels-reelwindow", "reelwindow" + ri], parentToAppend: this.slotWindowElement});
			let reelWindowElembackground: HTMLElement = CreateElement("div", {classes: ["spinnablereels-reelwindow", "reelwindow" + ri], parentToAppend: this.slotWindowElement});
			reelWindowElembackground.style.zIndex=ZIndex.ReelContainerBackground.toString();
			this.reelWindowElemsList.push(reelWindowElem);
			
			reelWindowElem.appendChild(reelWindowElembackground);
			
			// set reel background image, take into account border
			if (this.params.backgroundImage)
			{
				SetStyles(reelWindowElembackground, {
					borderStyle: "solid",
					borderImageSource: this.params.backgroundImage.CssBackground(),
					borderImageSlice: this.params.topBorderWidth + " " + this.params.rightBorderWidth + " " + this.params.bottomBorderWidth + " " + this.params.leftBorderWidth + " fill",
					borderImageWidth: this.params.topBorderWidth + "px " + this.params.rightBorderWidth + "px " + this.params.bottomBorderWidth + "px " + this.params.leftBorderWidth + "px",
					borderImageRepeat: "stretch",
					borderWidth: this.params.topBorderWidth + "px " + this.params.rightBorderWidth + "px " + this.params.bottomBorderWidth + "px " + this.params.leftBorderWidth + "px",
				});
			}

			let reelElem: HTMLElement = CreateElement("div", {classes: ["spinnablereels-reel", "reel" + ri], parentToAppend: reelWindowElem});
			reelElem.style.zIndex=ZIndex.ReelContainer.toString();
			this.reelElemsList.push(reelElem);

			// prepare symbols
			let incZIndex = this.extendedWindowSymbolSize.Height;
			for (let si = 0; si < this.extendedWindowSymbolSize.Height; si++) {

				let symbolElem: HTMLElement = CreateElement("div", {classes: ["spinnablereels-symbol", "symbol" + si], parentToAppend: reelElem, style: {
					width: this.symbolSize.Width + "px",
					height: this.symbolSize.Height + "px",
					zIndex: incZIndex.toString()
				}});

				let canvas: MyCanvas = new MyCanvas(this.symbolSize);

				symbolElem.appendChild(canvas.view);

				this.canvas[ri].push(canvas);

				this.symbolsContainer[ri].push(symbolElem);
				
				
				incZIndex--;
				
			}
			
		}
	}
	

	public GetView(): HTMLElement {
		return this.slotWindowElement;
	}

	/** window size in pixels */
	public GetWindowSize(): Size {
		return this.windowRect.Size();
	}

	/** window rect in pixels */
	public GetWindowRect(): Rect {
		return this.windowRect;
	}

	/** window size in number of symbols */
	public GetWindowSymbolSize(): PlayWindow {
		return this.windowSymbolSize;
	}

	/** extended window size in number of symbols - additional symbols are on top for the porpuse of spin animation */
	public GetExtendendWindowSymbolSize() {
		return this.extendedWindowSymbolSize;
	}

	/** returns size of one symbol in pixels */
	public GetSymbolSize() {
		return this.symbolSize;
	}

	public GetCenterOfReel(): Point []
	{

		this.reelWindowElemsList.forEach((reel:HTMLElement) =>
		{
			let r:ClientRect = reel.getBoundingClientRect();

			let width: number = r.width;
			let height: number = r.height;
			this.centerOfReel.push(new Point(width/2 + r.left, height/2 + r.height));
			
		});

		return this.centerOfReel;
	}

	public GetSymbolRect(column: number, row: number)
	{
		return new Rect(
			this.windowRect.x + this.params.leftBorderWidth + (column * this.symbolSize.Width),
			this.windowRect.y + this.params.topBorderWidth + this.params.bottomBorderWidth + (row * this.symbolSize.Height),
			this.symbolSize.Width,
			this.symbolSize.Height
		);
	}

	public GetAbsoluteSymbolRectReelRow(reel: number, rowOnReel: number)
	{
		return this.GetSymbolRect(reel, rowOnReel);
	}

	public CanvasesReelRow(): MyCanvas[][]
	{
		return this.canvas;
	}
}